import assets_load_data from '../assets/loader';
import { SDKManager } from '../lib/SDKManager';

export class BootScene extends Phaser.Scene {

  private loadingBar: Phaser.GameObjects.Graphics;
  private progressBar: Phaser.GameObjects.Graphics;
  private _hammerBanner: Phaser.GameObjects.Image;
  private _timeElapsed: number = 0;
  private _logo: Phaser.GameObjects.Image;

  public static isNewSession: boolean = true;

  constructor() {
    super({
      key: "BootScene"
    });
  }

  preload(): void {
    window.gameEvents = new Phaser.Events.EventEmitter();
    // window.gameEvents.on('StartGame', this.onGameLoad, this);
    // set the background and create loading bar
    this.cameras.main.setBackgroundColor(0x0b1636);
    this.createLoadingbar();

    // pass value to change the loading bar fill
    let loadingScreen = document.getElementById('loading-screen');
    // let loaderText = document.getElementById('loader-text');
    // let loaderBar = document.getElementById('loader-bar');

    // let item = document.getElementById('item');

    // loadingScreen.classList.remove('hide');

    this.load.on('start', function () {
      // if(window.game.gd_sdk) {
      // window.game.gd_sdk.preloadPrerollAd();
      // }
    })

    this.load.on('progress', function (value) {
      let percent = Math.floor((value * 100)) //+ "%"
      // window.progressBar(percent);
      // loaderBar.style.width = percent;
      // loaderText.innerText = percent
    });

    this.load.on('fileprogress', function (file) {
      // item.innerText = file.src;
      // console.log(file);

    });

    this.load.on('complete', function () {
      // window.constants["SDK"].onGameLoad();
      this._parseTileSet(this.cache.json.get("colliders").tiles);
      // loadingScreen.classList.add('hide');
      let w2 = Math.floor(window.constants["BASE_WIDTH"] * 0.5), h2 = Math.floor(window.constants["BASE_HEIGHT"] * 0.5);
      if (!window.constants["HD_FLAG"]) {
        this._hammerBanner = this.add.image(w2, h2, "hammer_banner");
        this._hammerBanner.setScale(0.88);
        this._timeElapsed = 0;
      }
      this.inGameSplashScreen();
    }, this);

    this._loadAssets(assets_load_data, (window.innerWidth > 300));
    // this.load.tilemapTiledJSON("colliders", "assets/data/colliders.json");
  }

  inGameSplashScreen() {
    SDKManager.firstFrameReady();
    let w2 = Math.floor(window.constants["BASE_WIDTH"] * 0.5), h2 = Math.floor(window.constants["BASE_HEIGHT"] * 0.5);
    this._logo = this.add.image(w2, h2, "logo");
    this._logo.setScale(1.5);
    this.time.delayedCall(2000, () => {
      this.onGameLoad();
    })
  }

  private canStartGame: boolean = false;

  onGameLoad() {
    // console.log("audio",window.constants["VOLUME"]);
    SDKManager.gameReady();
    this.canStartGame = true;
  }

  update(time, dt): void {
    if (this.canStartGame) {
      // localStorage.setItem("hammerplay_rampageroad_first", "false");
      SDKManager.getPlayerFirstTimeMetaData();
      if (!window.constants["HD_FLAG"]) {
        let delta = Math.floor(dt * 10) * 0.0001;
        this._timeElapsed += delta;
        if (this._timeElapsed > 2) {
          this.scene.start("MenuScene");
          if (!SDKManager.isFirstTime) {
            SDKManager.setPlayerFirstTimeMetaData(true);
            SDKManager.setPlayerHighscoreMetaData(0);
          }
          // if (!localStorage.getItem("hammerplay_rampageroad_first")) {
          //   localStorage.setItem("hammerplay_rampageroad_first", "true");
          //   localStorage.setItem("hammerplay_rampageroad_highscore", JSON.stringify(0));
          // }
        }
      } else {
        if (!SDKManager.isFirstTime) {
          SDKManager.setPlayerFirstTimeMetaData(true);
          SDKManager.setPlayerHighscoreMetaData(0);
        }
        // if (!localStorage.getItem("hammerplay_rampageroad_first")) {
        //   localStorage.setItem("hammerplay_rampageroad_first", "true");
        //   localStorage.setItem("hammerplay_rampageroad_highscore", JSON.stringify(0));
        // }
        this.scene.start("MenuScene");
      }
    }
  }

  private _loadAssets(assets, isHd) {
    for (let i = 0, length = assets.length; i < length; i++) {
      switch (assets[i].type) {
        case 'image':
          {
            let url = (isHd) ? assets[i].url_1 : assets[i].url_2;
            this.load.image(assets[i].name, url);
            break;
          }
        case 'font':
          {
            this.load.bitmapFont(assets[i].name, assets[i].texture, assets[i].data);
            break;
          }
        case "sprite-sheet":
          {
            let url, w, h;
            if (isHd) {
              url = assets[i].url_1;
              w = assets[i].width_1;
              h = assets[i].height_1;
            }
            else {
              url = assets[i].url_2;
              w = assets[i].width_2;
              h = assets[i].height_2;
            }
            this.load.spritesheet(assets[i].name, url, { frameWidth: w, frameHeight: h });
            break;
          }
        case "audio":
          {
            this.load.audio(assets[i].name, [assets[i].url_1, assets[i].url_2]);
            break;
          }
        case 'atlas':
          {
            let texture, data;
            if (isHd) {
              data = assets[i].data_1;
              texture = assets[i].texture_1;
              this.load.multiatlas(assets[i].name, data);
            } else {
              texture = assets[i].texture_2;
              data = assets[i].data_2;
            }
            // this.load.atlas(assets[i].name, texture, data);
          }
          break;
        case "json": {
          this.load.json(assets[i].name, assets[i].url);
        }
      }
    }
  }

  private _parseTileSet(tileset) {
    let colliders = {};
    for (let i = 0, length = tileset.length; i < length; i++) {
      let tile = tileset[i].objectgroup.objects[0];
      let name = tile.name.split("_");
      name.pop();
      name = name.join("_");
      tile.imagewidth = tileset[i].imagewidth;
      tile.imageheight = tileset[i].imageheight;
      tile.pivotX = ((tile.width * 0.5) + tile.x) / tile.imagewidth;
      tile.pivotY = ((tile.height * 0.5) + tile.y) / tile.imageheight;
      colliders[name] = tile;
    }
    window.constants["DATA"]["colliders"] = colliders;
  }

  private createLoadingbar(): void {
    this.loadingBar = this.add.graphics();
    this.loadingBar.fillStyle(0x0b1636, 1);
    this.loadingBar.fillRect(
      this.cameras.main.width / 4 - 2,
      this.cameras.main.height / 2 - 18,
      this.cameras.main.width / 2 + 4,
      20
    );
    this.progressBar = this.add.graphics();
  }
}
